import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('create_new'),
    headerButton: defineMessage('create'),
    searchPlaceholder: defineMessage('search_1'),
    readonlyBadge: defineMessage('readonly'),
    integrationDisconnected: defineMessage('disconnected_1'),
    airwallexDisconnected: defineMessage('disconnected_from_airwallex'),
    amCaptureBadge: defineMessage('approvalmax_capture'),
    noResults: defineMessage('looks_like_youre_not_a__istrators_to_get_access'),
};
